export const Filter = {
  PersonId: "personId" as const,
  PersonName: "personName" as const,
  YearMonth: "yearMonth" as const,
  PaymentDate: "paymentDate" as const,
  State: "state" as const,
  TaxesAndFees: "taxesAndFees" as const,
  Benefits: "benefits" as const,
  GrossSalary: "grossSalary" as const,
  IsActive: "isActive" as const,
}

